var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",attrs:{"buttons":['cancel', 'save'],"hide-header":"","persistent":""},on:{"save":function($event){return _vm.$refs.Form.save()}}},[_c('Form',{ref:"Form",attrs:{"centro-custo":_vm.centroCusto,"opcao-entrada":_vm.opcaoEntrada,"prioridades":_vm.prioridades},on:{"save":_vm.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }